import styled from '@emotion/styled';
import { Heading2, Heading3 } from '@blueprint/heading';
import { css } from '@emotion/react';

const StyledMainFooter = styled('footer')((props) => {
    const {
        theme: { colors, spacing, pageWidth, stickyBarHeight }
    } = props;

    return css`
        background-color: ${colors['graphic-background-accent-light']};
        padding-bottom: calc(${spacing['64px']} + ${stickyBarHeight});

        & > * > * {
            max-width: ${pageWidth}px;
            margin: auto;
        }
    `;
});

const hideStyling = css`
    &:not(:focus):not(:active) {
        width: 1px;
        height: 0;
        padding: 0;
        -webkit-clip-path: inset(100%);
        clip-path: inset(100%);
        clip: rect(0 0 0 0);
        overflow: hidden;
    }
`;

const StyledHiddenHeading2 = styled(Heading2)(hideStyling);
const StyledHiddenHeading3 = styled(Heading3)(hideStyling);

const StyledList = styled('ul')((props) => {
    const {
        theme: { spacing, mq }
    } = props;

    return css`
        margin: 0;
        padding: ${spacing['spacing-2']} ${spacing['spacing-2']} 0
            ${spacing['spacing-2']};

        ${mq.small} {
            padding: ${spacing['spacing-3']} ${spacing['spacing-4']} 0
                ${spacing['spacing-4']};
        }

        ${mq.large} {
            padding: ${spacing['spacing-3']} ${spacing['spacing-4']} 0
                ${spacing['spacing-4']};
        }
    `;
});

const ListItem = styled('li')`
    list-style: none;
`;

export {
    StyledMainFooter,
    StyledHiddenHeading2,
    StyledHiddenHeading3,
    StyledList,
    ListItem
};
